import { defineAsyncComponent } from 'vue'
export default {
  articles: defineAsyncComponent(() => import("D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/layouts/articles.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/layouts/default.vue").then(m => m.default || m))
}